const formLabelFormParamUser = {
  text: 'Type of Access'
};

export default formLabelFormParamUser;
